<template>
  <div id="confirmed">
    <div v-if="searching">
      <strong>Loading. Please wait...</strong>
    </div>
    <div v-if="!searching">
            <h1>Confirmed Faces</h1>
    </div>
    <div v-if="faces_confirmed && faces_confirmed.length && !searching" class="confirmed-list">
      <div v-for="confirmed of facesConfirmedFiltered" class="confirmed-list-entry" v-bind:key="confirmed.runtime_face_uuid">
        <div class="left-info-area">
          <router-link v-bind:to="'/faces/' + confirmed.person_name" class="face-name">{{confirmed.person_name}}</router-link><br/>
          {{confirmed.camera_description}}<br/>
          {{getTimeString(confirmed.captured_at)}}<br/>
        </div>
        <div class="frontend-image-area">
          <img v-lazy="confirmed.frontend_image_uri" height=160 class="frontend-image"/>
        </div>
        <div class="runtime-image-area">
          <!-- <img v-lazy="BASE_URL + '/api/v4/faceimage/' + confirmed.runtime_face_uuid" height=160 class="runtime-image"></img> -->
          <img :src="'https://yakov.owal.io/api/v6/faces/images/' + confirmed.runtime_face_uuid + '?shape=1&clahe=1'" height='160dp' class="runtime-image"/>
          <!-- <img v-lazy="BASE_URL + '/api/v4/faceimage/' + confirmed.runtime_face_uuid" height=160 class="runtime-image"></img> -->
        </div>
        <div id="right-info-area">
          Tagged by {{confirmed.tagged_by}}<br/>
          {{confirmed.confirmed_at && getTimeDiff(confirmed.confirmed_at)}}
        </div>
        <button class="ui button" v-on:click="wrongShape(confirmed.frontend_face_uuid, confirmed.runtime_face_uuid)">Wrong Shape &amp; Remove</button>
        <button class="ui negative button" v-on:click="removeConfirm(confirmed.frontend_face_uuid, confirmed.runtime_face_uuid)">Remove</button>
      </div>
      <infinite-loading :on-infinite="getMoreResults" ref="infiniteLoading" v-if="more_available"></infinite-loading>
    </div>
    <div v-if="!searching && faces_confirmed && !faces_confirmed.length">
      No results.
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import momenttz from 'moment-timezone';
import InfiniteLoading from 'vue-infinite-loading';

import {facesconfirmed, facematchconfirm, facewrongshape} from '../api/faces';
import {BASE_URL} from '../api/base';

const BATCH_SIZE = 50;

export default {
  name: 'faces-detected',
  data: () => {
    return {
      faces_confirmed: [],
      searching: true,
      BASE_URL,
      highest_index: BATCH_SIZE,
      more_available: true,
    }
  },
  watch: {
    '$route': function() {
      this.updateResults()
    }
  },
  created() {
    this.updateResults()
  },
  computed: {
    facesConfirmedFiltered() {
      if (!this.$route.params.frontend_face_uuid) {
        const slice_end = Math.min(this.highest_index, this.faces_confirmed.length);
        console.log(`highest_index = ${this.highest_index} faces_confirmed.length = ${this.faces_confirmed.length} slice_end=${slice_end}`)
        return this.faces_confirmed.slice(0, slice_end);
      } else {
        const filtered = this.faces_confirmed.filter(x => x.frontend_face_uuid == this.$route.params.frontend_face_uuid);
        const slice_end = Math.min(this.highest_index, filtered.length);
        console.log(`highest_index = ${this.highest_index} faces_confirmed.length = ${this.faces_confirmed.length} filtered.length = ${filtered.length} slice_end=${slice_end}`)
        return filtered.slice(0, slice_end);
      }
    }
  },
  methods: {
    updateResults() {
      this.searching = true;
      const args = {};
      facesconfirmed().then(res => res.data).then(data => {
        if (!data.ok) {
          return alert(data.err);
        }
        this.faces_confirmed = data.faces_confirmed;
        this.searching = false;
      }).catch((err) => {
        console.log(err);
      })
    },
    getMoreResults() {
      // // v2 only
      // if (this.searching) return;
      // console.log(`Getting more results, offset=${this.faces_confirmed.length}`);
      // facesconfirmed(this.faces_confirmed.length).then(res => res.data).then(data => {
      //   if (!data.ok) {
      //     return alert(data.err);
      //   }
      //   this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
      //   this.faces_confirmed = this.faces_confirmed.concat(data.faces_confirmed);
      // });
      // updateResults() will fetch _all_ results. But we don't want to show that.
      let max = 0;
      if (!this.$route.params.frontend_face_uuid) {
        max = this.faces_confirmed.length;
      } else {
        const filtered = this.faces_confirmed.filter(x => x.frontend_face_uuid == this.$route.params.frontend_face_uuid);
        max = filtered.length;
      }
      this.highest_index = Math.min(this.highest_index + BATCH_SIZE, max);
      console.log(`max=${max} highest_index = ${this.highest_index}`);
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
      if (this.highest_index == max) {
        this.more_available = false;
      }
    },
    removeConfirm(frontend_face_uuid, runtime_face_uuid) {
      facematchconfirm(runtime_face_uuid, frontend_face_uuid).then(res => res.data).then(data => {
        if (!data.ok) {
          return alert(data.err);
        }
        const new_faces_confirmed = this.faces_confirmed;
        new_faces_confirmed.splice(new_faces_confirmed.findIndex(x => x.runtime_face_uuid === runtime_face_uuid), 1);
        this.faces_confirmed = new_faces_confirmed;
      }).catch((err) => {
        console.log(err);
      });
    },
    getTimeDiff(time_str) {
      console.log(time_str);
      return moment.utc(time_str).fromNow();
    },
    getTimeString(time_str) {
      return moment.utc(time_str).tz('America/New_York').format("dddd, MMMM Do YYYY, h:mm:ss a");
    },
    wrongShape(frontend_face_uuid, runtime_face_uuid) {
      facewrongshape(runtime_face_uuid).then(res => res.data).then(data => {
        if (!data.ok) {
          console.error('facewrongshape error');
          return;
        }
        this.removeConfirm(frontend_face_uuid, runtime_face_uuid)
      })
    }
  },
  updated() {
    // this.updateAllImages();
  },
  components: {
    InfiniteLoading,
  },
}
</script>

<style scoped>

a {
  color: black;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}

.faces-list {
  background-color: white;
  padding: 20px;
}

.faces-list-entry {
  border: 1px solid black; 
  margin: 10px 10px 10px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.faces-list-entry-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: left;
  /* border: 1px dashed blue;  */
}

.face-image-area {
  display: flex;
  flex-direction: row;
  margin: 0px;
  /* border: 1px dashed green; */
}

.the-image {
  /* border: 1px dashed orange; */
}

.matches-area {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.potential-match {
  padding-left: 10px;
}

.camera-description {
  font-size: large;
}

.captured-at-diff {
  font-size: large;
}

.captured-at-string {
  font-size: small;
}

.potential-match-name-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.potential-match-name {
  padding-left: 10px;
}

#circle {
  width: 10px;
  height: 10px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  background: red;
  margin-right: 10px;
}

.confirmed-list-entry {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.confirmed-list-entry button {
  visibility: hidden;
}

.confirmed-list-entry:hover button {
  visibility: visible;
}

.face-name {
  padding-right: 10px;
}

.frontend-image-area {
  width: 300px;
}

.runtime-image-area {
  width: 300px;
}

</style>


// WEBPACK FOOTER //
// Confirmed.vue?24625d91